import axiosClient from '../libs/axios';

// Organizasyon tipleri
export const ORGANIZATION_TYPES = {
  COMPANY: 1,
  NGO: 2,
  GOVERNMENT: 3,
  EDUCATIONAL: 4,
  OTHER: 5
};

// Kullanıcı durumları
export const USER_STATUS = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2
};

// Proje durumları
export const PROJECT_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1
};

// Tüm organizasyonları getir
export const getOrganizations = async () => {
  try {
    const response = await axiosClient.get('/organizations');
    return response.data.organizations || [];
  } catch (error) {
    console.error('getOrganizations error:', error);
    throw error;
  }
};

// Slug'a göre organizasyon getir
export const getOrganizationBySlug = async (slug) => {
  try {
    const response = await axiosClient.get(`/organizations/get/byslug/${slug}`);
    return response.data.organization;
  } catch (error) {
    console.error('getOrganizationBySlug error:', error);
    throw error;
  }
};

// Organizasyon ara
export const searchOrganization = async (slug) => {
  try {
    const response = await axiosClient.get(`/organizations/search/${slug}`);
    return response.data;
  } catch (error) {
    console.error('searchOrganization error:', error);
    throw error;
  }
};

// ID'ye göre organizasyon getir
export const getOrganizationById = async (id) => {
  try {
    const response = await axiosClient.get(`/organizations/get/byid/${id}`);
    return response.data;
  } catch (error) {
    console.error('getOrganizationById error:', error);
    throw error;
  }
};

// Organizasyon oluştur
export const createOrganization = async (organizationData) => {
  try {
    const response = await axiosClient.post('/organizations/create', organizationData);
    return response.data;
  } catch (error) {
    console.error('createOrganization error:', error);
    throw error;
  }
};

// Organizasyon güncelle
export const updateOrganization = async (slug, organizationData) => {
  try {
    const response = await axiosClient.post(`/organizations/update/${slug}`, organizationData);
    return response.data;
  } catch (error) {
    console.error('updateOrganization error:', error);
    throw error;
  }
};

// Organizasyon sil
export const deleteOrganization = async (slug) => {
  try {
    const response = await axiosClient.delete(`/organizations/${slug}`);
    return response.data;
  } catch (error) {
    console.error('deleteOrganization error:', error);
    throw error;
  }
};

// Organizasyon genel görünümü
export const getOrganizationOverview = async (slug) => {
  try {
    const response = await axiosClient.get(`/organizations/overview/${slug}`);
    return response.data;
  } catch (error) {
    console.error('getOrganizationOverview error:', error);
    throw error;
  }
};

// Organizasyona kullanıcı ekle
export const addUserToOrganization = async (organizationId, userId) => {
  try {
    const response = await axiosClient.post('/organizations/addUser', {
      organization_id: organizationId,
      user_id: userId
    });
    return response.data;
  } catch (error) {
    console.error('addUserToOrganization error:', error);
    throw error;
  }
};

// Organizasyondan kullanıcı sil
export const removeUserFromOrganization = async (organizationId, userId) => {
  try {
    const response = await axiosClient.post('/organizations/deleteUser', {
      organization_id: organizationId,
      user_id: userId
    });
    return response.data;
  } catch (error) {
    console.error('removeUserFromOrganization error:', error);
    throw error;
  }
};

// Organizasyona proje ekle
export const addProjectToOrganization = async (organizationId, projectId) => {
  try {
    const response = await axiosClient.post('/organizations/addProject', {
      organization_id: organizationId,
      project_id: projectId
    });
    return response.data;
  } catch (error) {
    console.error('addProjectToOrganization error:', error);
    throw error;
  }
};

// Organizasyondan proje sil
export const removeProjectFromOrganization = async (organizationId, projectId) => {
  try {
    const response = await axiosClient.post('/organizations/deleteProject', {
      organization_id: organizationId,
      project_id: projectId
    });
    return response.data;
  } catch (error) {
    console.error('removeProjectFromOrganization error:', error);
    throw error;
  }
};

// Organizasyon tipi oluştur
export const createOrganizationType = async (typeData) => {
  try {
    const response = await axiosClient.post('/organizations/createType', typeData);
    return response.data;
  } catch (error) {
    console.error('createOrganizationType error:', error);
    throw error;
  }
};

// Tüm organizasyon tiplerini getir
export const getOrganizationTypes = async () => {
  try {
    const response = await axiosClient.get('/organizations/getAllTypes');
    return response.data.types || [];
  } catch (error) {
    console.error('getOrganizationTypes error:', error);
    throw error;
  }
};

// Organizasyon tipi güncelle
export const updateOrganizationType = async (id, typeData) => {
  try {
    const response = await axiosClient.post(`/organizations/updateType/${id}`, typeData);
    return response.data;
  } catch (error) {
    console.error('updateOrganizationType error:', error);
    throw error;
  }
};

// Organizasyon tipi sil
export const deleteOrganizationType = async (id) => {
  try {
    const response = await axiosClient.post(`/organizations/deleteType/${id}`);
    return response.data;
  } catch (error) {
    console.error('deleteOrganizationType error:', error);
    throw error;
  }
};

// Tüm bekleyen kullanıcı isteklerini getir
export const getOrganizationRequests = async () => {
  try {
    const response = await axiosClient.get('/organizations/getRequests');
    return response.data.requests || [];
  } catch (error) {
    console.error('getOrganizationRequests error:', error);
    throw error;
  }
};

// Slug'a göre organizasyon isteklerini getir
export const getOrganizationRequestsBySlug = async (slug) => {
  try {
    const response = await axiosClient.get(`/organizations/requests/${slug}`);
    return response.data.requests || [];
  } catch (error) {
    console.error('getOrganizationRequestsBySlug error:', error);
    throw error;
  }
};

// Organizasyona katılım isteği gönder
export const joinOrganization = async (slug) => {
  try {
    const response = await axiosClient.post(`/organizations/join/${slug}`);
    return response.data;
  } catch (error) {
    console.error('joinOrganization error:', error);
    throw error;
  }
};

// Kullanıcı isteğini kabul et
export const acceptOrganizationRequest = async (requestId) => {
  try {
    const response = await axiosClient.post(`/organizations/acceptRequest/${requestId}`);
    return response.data;
  } catch (error) {
    console.error('acceptOrganizationRequest error:', error);
    throw error;
  }
};

// Kullanıcı isteğini reddet
export const rejectOrganizationRequest = async (requestId) => {
  try {
    const response = await axiosClient.post(`/organizations/rejectRequest/${requestId}`);
    return response.data;
  } catch (error) {
    console.error('rejectOrganizationRequest error:', error);
    throw error;
  }
};

// Organizasyon kullanıcılarını getir
export const getOrganizationUsers = async (organizationId) => {
  try {
    const response = await axiosClient.get(`/organizations/users/${organizationId}`);
    return response.data.organization || [];
  } catch (error) {
    console.error('getOrganizationUsers error:', error);
    throw error;
  }
};

// Helper fonksiyonlar
export const getOrganizationTypeLabel = (type) => {
  const typeLabels = {
    [ORGANIZATION_TYPES.COMPANY]: 'Şirket',
    [ORGANIZATION_TYPES.NGO]: 'STK',
    [ORGANIZATION_TYPES.GOVERNMENT]: 'Kamu',
    [ORGANIZATION_TYPES.EDUCATIONAL]: 'Eğitim',
    [ORGANIZATION_TYPES.OTHER]: 'Diğer'
  };
  return typeLabels[type] || 'Bilinmeyen';
};

export const getUserStatusLabel = (status) => {
  const statusLabels = {
    [USER_STATUS.PENDING]: 'Beklemede',
    [USER_STATUS.APPROVED]: 'Onaylandı',
    [USER_STATUS.REJECTED]: 'Reddedildi'
  };
  return statusLabels[status] || 'Bilinmeyen';
};

export const getUserStatusColor = (status) => {
  const statusColors = {
    [USER_STATUS.PENDING]: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300',
    [USER_STATUS.APPROVED]: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
    [USER_STATUS.REJECTED]: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300'
  };
  return statusColors[status] || 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-300';
};

export const getProjectStatusLabel = (status) => {
  const statusLabels = {
    [PROJECT_STATUS.INACTIVE]: 'Pasif',
    [PROJECT_STATUS.ACTIVE]: 'Aktif'
  };
  return statusLabels[status] || 'Bilinmeyen';
};

export const getProjectStatusColor = (status) => {
  const statusColors = {
    [PROJECT_STATUS.INACTIVE]: 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-300',
    [PROJECT_STATUS.ACTIVE]: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300'
  };
  return statusColors[status] || 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-300';
};

// Formatting fonksiyonları
export const formatOrganizationFromApi = (apiOrg) => {
  return {
    id: apiOrg.id,
    title: apiOrg.organization_title || apiOrg.title,
    description: apiOrg.organization_description || apiOrg.description,
    slug: apiOrg.organization_slug || apiOrg.slug,
    image: apiOrg.organization_image || apiOrg.image,
    type: apiOrg.organization_type || apiOrg.type,
    createdAt: apiOrg.created_at,
    updatedAt: apiOrg.updated_at,
    users: apiOrg.organizations_users || [],
    projects: apiOrg.organizations_projects || []
  };
};

export const formatOrganizationForApi = (org) => {
  return {
    organization_title: org.title,
    organization_description: org.description,
    organization_slug: org.slug,
    organization_type: org.type
  };
};
